import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { viewCategoryAction } from '../../actions';
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import Loader from "react-loader-spinner";

function CategoryView({ viewCategoryAction }) {
    const [categoryData, setCategoryData] = useState(null);
    const history = useHistory();
    const params = useParams();
    const id = params.id;

    useEffect(() => {
        viewCategoryAction({ id: id }, (err, response) => {
            if (!err) {
                setCategoryData(response.data.data);
            }
        });
    }, [id, viewCategoryAction]);

    return (
        <div className="col-lg-12">
            <div className="card">
                {
                    categoryData ?
                        <>
                            <div className="header d-flex justify-content-between align-items-center">
                                <h2>
                                    {categoryData.title}
                                </h2>
                                <button onClick={() => { history.push(`/category-item/${categoryData._id}`) }} className="btn btn-outline-secondary" >Items</button>
                            </div>
                            <div className="body table-responsive">
                                <table className="table table-hover">
                                    <tbody>
                                        <tr>
                                            <th>Title:</th>
                                            <td>{categoryData.title}</td>

                                        </tr>
                                        <tr>
                                            <th>Image:</th>
                                            <td><img width="60" src={categoryData.imagePath} className="rounded" /></td>
                                        </tr>

                                        <tr>
                                            <th>Created At:</th>
                                            <td>{moment(categoryData.createdAt).format('YYYY-MM-DD hh:mm a')}</td>
                                        </tr>
                                    </tbody>
                                </table>

                            </div>
                        </> :
                        <div className="text-center">
                            <Loader
                                type="Bars"
                                color="#00BFFF"
                                height={100}
                                width={100}
                                timeout={3000} //3 secs
                            />
                        </div>

                }

            </div>
        </div>
    )
}

export default connect(null, { viewCategoryAction })(CategoryView)